import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './enquiry.component.scss';
import * as $ from 'jquery';
var Enquiry = /** @class */ (function (_super) {
    tslib_1.__extends(Enquiry, _super);
    function Enquiry(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    Enquiry.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-enquiry-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-enquiry-modal-open'));
        this.closeButton = this.element.querySelector('.js-enquiry-modal-close');
        this.enquiryForm = this.element.querySelector('form');
        this.formSubmitButton = this.element.querySelector('.js-enquiry-submit');
        this.formSuccessMessage = this.element.querySelector('.js-enquiry-success-message');
        this.formBusinessType = this.element.querySelector('.js-business-type');
        this.formFields = this.element.querySelector('.js-enquiry-form-fields');
        this.formFieldsRB = this.element.querySelector('.js-enquiry-form-fields-registered-business');
        this.formStoreLocatorMessage = this.element.querySelector('.js-enquiry-store-locator-message');
    };
    Enquiry.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        if (this.formBusinessType) {
            this.formBusinessType.addEventListener('change', function () { return _this.validateBusinessType(); });
        }
        this.formSubmitButton.addEventListener('click', function () {
            var formFields = _this.enquiryForm.querySelectorAll('input, select');
            var validation = _this.validationService.validate(formFields);
            if (validation.valid) {
                _this.formsService.detect(_this.enquiryForm, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
            }
        });
    };
    Enquiry.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    Enquiry.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-enquiry-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    Enquiry.prototype.closeModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
        setTimeout(function () {
            _this.hideSuccessMessage();
        }, 500);
    };
    Enquiry.prototype.openModal = function () {
        this.resetForm();
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    Enquiry.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    Enquiry.prototype.submitForm = function (event) {
        event.preventDefault();
        this.showSuccessMessage();
    };
    Enquiry.prototype.validateBusinessType = function () {
        if (this.formBusinessType.value === 'business-type-2') {
            this.showBusinessRegistrationNumber('idNumber');
            this.showStoreLocatorMessage();
        }
        else if (this.formBusinessType.value === 'Other') {
            this.showBusinessRegistrationNumber('businessReg');
        }
        else {
            this.showBusinessRegistrationNumber('idNumber');
            this.hideStoreLocatorMessage();
        }
    };
    Enquiry.prototype.showBusinessRegistrationNumber = function (type) {
        if (type === 'businessReg') {
            var field = this.enquiryForm.querySelector('input.form__input--identification');
            var formGroup = $(field).closest('.form__group');
            formGroup.removeClass('form__group--error');
            var label = formGroup.find('label').text('Business Registration Number');
            field.setAttribute('name', 'business-reg-number');
            field.classList.remove('form__input--identification');
            field.classList.add('form__input--business-registration');
            field.placeholder = 'Enter your business registration number';
        }
        else {
            var field = this.enquiryForm.querySelector('input.form__input--business-registration');
            var formGroup = $(field).closest('.form__group');
            formGroup.removeClass('form__group--error');
            var label = formGroup.find('label').text('ID Number');
            field.setAttribute('name', 'id-number');
            field.classList.remove('form__input--required');
            field.classList.add('form__input--identification');
            field.placeholder = 'Enter your South African ID number';
        }
    };
    Enquiry.prototype.showStoreLocatorMessage = function () {
        this.formFields.classList.remove('enquiry__form-fields--visible');
        this.formStoreLocatorMessage.classList.add('enquiry__message--visible');
    };
    Enquiry.prototype.hideStoreLocatorMessage = function () {
        this.formFieldsRB.classList.remove('enquiry__form-fields--visible');
        this.formStoreLocatorMessage.classList.remove('enquiry__message--visible');
        this.formFields.classList.add('enquiry__form-fields--visible');
    };
    Enquiry.prototype.showSuccessMessage = function () {
        this.enquiryForm.classList.remove('enquiry__form--visible');
        this.formSuccessMessage.classList.add('enquiry__message--visible');
    };
    Enquiry.prototype.hideSuccessMessage = function () {
        this.formSuccessMessage.classList.remove('enquiry__message--visible');
        this.enquiryForm.classList.add('enquiry__form--visible');
    };
    Enquiry.prototype.resetForm = function () {
        if (this.enquiryForm) {
            this.enquiryForm.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    return Enquiry;
}(Base));
export { Enquiry };



//////////////////
// WEBPACK FOOTER
// ./components/enquiry/enquiry.component.ts
// module id = 265
// module chunks = 0